/**
 * Checks if a given prop exists on an Object
 */
function hasOwn(obj: { [key: string]: any }, key: string) {
  return {}.hasOwnProperty.call(obj || {}, key);
}

export default hasOwn;
